import React, {useEffect} from "react";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getValidatedLimit} from "../../components/Utility";
import {fetchInvoiceById} from "../../store/manual-pdf-slice";
import ManualInvoice from "../../components/htmlToPdf/ManualInvoice";

const DetailedInvoice = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {items, pagination, fetchByIdStatus} = useSelector(state => state.manualPdf);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const userRole = useSelector((state) => state.auth.selectedRole);


    const item = items.find(item => item.id === params.invoiceId);

    useEffect(() => {
        dispatch(fetchInvoiceById({...userRole, id: params.invoiceId}));
    }, [dispatch, params.invoiceId, userRole]);

    return (
        <>
            <SubHeader title="Invoice Details" />
            {fetchByIdStatus === 'success' &&
                <div className="position-relative end-0">
                    <ManualInvoice invoice={item} detail= {true} pagination={{ limit, currentPage }} />
                </div>
            }
        </>
    );
}
export default DetailedInvoice;

